export default "__VITE_ASSET__JWChOAmM__"